export const MODAL_NAME = 'PodcastSearch';
